import { render, staticRenderFns } from "./vehicleInspection.vue?vue&type=template&id=a44e36f2"
import script from "./vehicleInspection.vue?vue&type=script&lang=js"
export * from "./vehicleInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports